<template>
  <v-layout>
    <MainMenu :quantity="quantity" />
    <v-layout column>
      <v-layout>
        <v-flex>
          <router-view />
        </v-flex>
      </v-layout>
      <v-layout align-end>
        <v-flex class="footer-wrap">
          <div class="page-content-paddings">
            <AppFooter class="mb-3" />
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import MainMenu from '@/components/widgets/menu/MainMenu';
import AppFooter from '@/components/widgets/AppFooter';

export default {
    name: 'QualifiedFamiliesPage',
    components: {
        AppFooter,
        MainMenu
    },
    computed: {
        quantity () {
            return this.$store.getters['acceptedFamilies/getAcceptedFamiliesQuantity'];
        }
    }
};
</script>

<style scoped></style>
